import { switchingFetch, type UpdatedFetchArgs } from '../issue/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (args: UpdatedFetchArgs) => switchingFetch(args);
